import { Outlet } from "react-router";
import { AuthSessionWatcher } from "../AuthSessionWatcher";
import { BackgroundTokenRefresh } from "../BackgroundTokenRefresh";

export function RootLayout() {
  return (
    <>
      <AuthSessionWatcher />
      <BackgroundTokenRefresh />
      <Outlet />
    </>
  );
}
